import axios from 'axios';
import { authHeader } from './authHeader';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export const giftService = {
  /**
   * Send a creator a one-off gift of credits. The backend takes the sender from
   * the token and debits the credits in its own transaction; the HTTP status
   * comes back so the caller can tell "not enough credits" (400) from a missing
   * creator (404).
   *
   * `amountCredits` goes on the wire as a JSON number: the backend's
   * parseGiftAmount refuses anything where `typeof value !== 'number'`.
   *
   * The response also carries `creatorEarnings`. It is deliberately not read:
   * the fan is never shown the creator's share or the platform commission.
   */
  async sendGift(creatorId: string, amountCredits: number): Promise<{
    success: boolean;
    message: string;
    status?: number;
    amountCredits?: number | null;
  }> {
    try {
      const headers = await authHeader();
      if (!headers) {
        return { success: false, message: 'Please log in again.', status: 401 };
      }

      const response = await axios.post(
        `${API_URL}/api/gifts/${encodeURIComponent(creatorId)}`,
        { amountCredits },
        { headers },
      );

      const sent = response.data?.amountCredits;

      return {
        success: true,
        message: 'Gift sent',
        status: response.status,
        amountCredits: typeof sent === 'number' ? sent : null,
      };
    } catch (error: any) {
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Failed to send gift',
        status: error.response?.status,
      };
    }
  },
};
